/*
 * Copyright (c) 2026. Tooling Team
 */

import { formatCellValue } from "../../utils/formatters";

const LoincDescriptionCell = (cell) => {
  const editActions = cell.table?.options?.meta?.editActions;
  const isRowInEditMode = editActions?.rowsInEditMode?.[cell.row?.id];
  const displayData = cell.row?.original?.["loincConcept"]?.description;

  if (isRowInEditMode) {
    const tempData = editActions?.getTempEditedData?.(cell.row?.index);
    if (tempData && "loincConceptDescription" in tempData) {
      return formatCellValue(tempData["loincConceptDescription"]);
    }
  }

  return formatCellValue(displayData);
};

export default LoincDescriptionCell;
